import { inject } from '@angular/core';

import { Logger, WindowRef } from '@frontend/vanilla/core';

import { VIEW_TRANSITION_LOG_TAG as LOG_TAG, NAVIGATION_HAS_NATIVE_TRANSITION_MESSAGE } from '../../view-transition.constants';
import { NativeTransitionDetectionStrategy } from './native-transition-detection.strategy.model';

export class NavigationApiNativeTransitionDetectionStrategy implements NativeTransitionDetectionStrategy {
    private logger = inject(Logger);
    private navigation = inject(WindowRef).nativeWindow.navigation;
    private _navigationHasNativeTransition = false;

    get navigationHasNativeTransition(): boolean {
        return this._navigationHasNativeTransition;
    }

    init(): this {
        this.listenForNativeTransitions();

        return this;
    }

    private listenForNativeTransitions(): void {
        this.navigation.addEventListener('navigate', (event: NavigateEvent) => {
            if (event.hasUAVisualTransition) {
                this.logger.info(`${LOG_TAG} ${NAVIGATION_HAS_NATIVE_TRANSITION_MESSAGE}`);
            }

            this._navigationHasNativeTransition = event.hasUAVisualTransition;
        });
    }
}
